import { AxiosError } from "axios";
import * as Sentry from "@sentry/vue";
import { translateError } from "./translateError.helper";

export const handleAxiosError = (error: AxiosError | unknown) => {
  if (error instanceof AxiosError) {
    Sentry.captureMessage(`Unexpected Axios-Error`, {
      extra: { message: error.message },
    });
  }
  return translateError("INTERNAL_ERROR");
};
